export default {
  init() {
    console.log(frontend_ajax_object);
    if(frontend_ajax_object.timerDate.length > 0){

      var date = frontend_ajax_object.timerDate;
      if (document.getElementById("timer")) {
        // Set the date we're counting down to
        var countDownDate = new Date(date).getTime();
  
        // Update the countdown every 1 second
        var x = setInterval(function () {
          // Get the current date and time
          var now = new Date().getTime();
  
          // Calculate the time remaining
          var timeRemaining = countDownDate - now;
  
          // Calculate days, hours, minutes, and seconds
          var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var minutes = Math.floor(
            (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
          );
          var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
  
          if (days < 10) {
            var days = "0" + Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
          }
  
          if (hours < 10) {
            var hours =
              "0" +
              Math.floor(
                (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
              );
          }
  
          if (minutes < 10) {
            var minutes =
              "0" + Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
          }
  
          if (seconds < 10) {
            var seconds = "0" + Math.floor((timeRemaining % (1000 * 60)) / 1000);
          }
  
          // Display the countdown in the element with id="timer"
          document.getElementById("days").innerHTML = days;
          document.getElementById("hours").innerHTML = hours;
          document.getElementById("minutes").innerHTML = minutes;
          document.getElementById("seconds").innerHTML = seconds;
        }, 1000);
      }
    }
  },
  finalize() {},
};
